// NOTE: KmzServiceClient was removed from proto - this hook is deprecated
// but kept for backward compatibility with useGrpcService
export const useGrpcClient = () => {
    // KmzService was removed from proto - always return connected status
    // Other services (UserProjects, Payment, etc.) handle their own clients
    const isConnected = true;
    const connectionError = null;
    return {
        isConnected,
        connectionError
    };
};
